import React from "react";

const SwimmingEventDetails = ({ events, userNames, styles }) => {
  // Helper function to get player name
  const getPlayerName = (participant) => {
    // For custom players, use the name directly
    if (participant.isCustom || !participant.userId) {
      return participant.name || "Guest Player";
    }
    // For system users, look up their name
    if (participant.userId === "guest") return "Guest Player";
    return (
      userNames[participant.userId] ||
      participant.name ||
      `Player ${participant.userId}`
    );
  };

  return events.map((event, eventIndex) => (
    <div
      key={eventIndex}
      style={{
        marginBottom: "clamp(15px, 4vw, 20px)",
        padding: "clamp(12px, 3vw, 15px)",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      <h4
        style={{
          color: "#2c3e50",
          marginBottom: "clamp(12px, 3vw, 15px)",
          fontSize: "clamp(16px, 3.5vw, 20px)",
        }}
      >
        🏊‍♂️ Swimming Event #{eventIndex + 1}
      </h4>

      <div
        style={{
          marginBottom: "clamp(12px, 3vw, 15px)",
          fontSize: "clamp(13px, 2.5vw, 15px)",
        }}
      >
        <p style={{ marginBottom: "clamp(6px, 1.5vw, 8px)" }}>
          <strong>Event:</strong>{" "}
          {event.eventName ||
            `${event.distance}m ${event.stroke.replace("-", " ")}`}
        </p>
        <p style={{ marginBottom: "clamp(6px, 1.5vw, 8px)" }}>
          <strong>Type:</strong>{" "}
          {event.eventType === "individual" ? "Individual" : "Relay"}
        </p>
        <p style={{ marginBottom: "clamp(6px, 1.5vw, 8px)" }}>
          <strong>Distance:</strong> {event.distance}m
        </p>
        <p style={{ marginBottom: "clamp(6px, 1.5vw, 8px)" }}>
          <strong>Stroke:</strong> {event.stroke.replace("-", " ")}
        </p>
        <p style={{ marginBottom: "clamp(6px, 1.5vw, 8px)" }}>
          <strong>Pool:</strong> {event.poolLength}m
        </p>
      </div>

      {event.eventType === "individual" && event.participants && (
        <div>
          <h5
            style={{
              color: "#34495e",
              marginBottom: "clamp(8px, 2vw, 10px)",
              fontSize: "clamp(14px, 3vw, 16px)",
            }}
          >
            Results
          </h5>
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "clamp(12px, 2.5vw, 14px)",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#ecf0f1" }}>
                  <th
                    style={{
                      padding: "clamp(6px, 1.5vw, 8px)",
                      border: "1px solid #bdc3c7",
                    }}
                  >
                    Place
                  </th>
                  <th
                    style={{
                      padding: "clamp(6px, 1.5vw, 8px)",
                      border: "1px solid #bdc3c7",
                    }}
                  >
                    Lane
                  </th>
                  <th
                    style={{
                      padding: "clamp(6px, 1.5vw, 8px)",
                      border: "1px solid #bdc3c7",
                    }}
                  >
                    Swimmer
                  </th>
                  <th
                    style={{
                      padding: "clamp(6px, 1.5vw, 8px)",
                      border: "1px solid #bdc3c7",
                    }}
                  >
                    Time
                  </th>
                  <th
                    style={{
                      padding: "clamp(6px, 1.5vw, 8px)",
                      border: "1px solid #bdc3c7",
                    }}
                  >
                    Reaction
                  </th>
                </tr>
              </thead>
              <tbody>
                {event.participants
                  .sort((a, b) => a.place - b.place)
                  .map((participant, pIndex) => (
                    <tr
                      key={pIndex}
                      style={{
                        backgroundColor:
                          participant.place === 1 ? "#fff3cd" : "white",
                      }}
                    >
                      <td
                        style={{
                          padding: "clamp(6px, 1.5vw, 8px)",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {participant.place > 0
                          ? participant.place === 1
                            ? "🥇"
                            : participant.place === 2
                            ? "🥈"
                            : participant.place === 3
                            ? "🥉"
                            : participant.place
                          : "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {participant.lane}
                      </td>
                      <td
                        style={{ padding: "8px", border: "1px solid #bdc3c7" }}
                      >
                        {getPlayerName(participant)}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        {participant.finalTime || "N/A"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #bdc3c7",
                          textAlign: "center",
                        }}
                      >
                        {participant.reaction || "-"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {event.eventType === "relay" && event.relayTeams && (
        <div>
          <h5
            style={{
              color: "#34495e",
              marginBottom: "clamp(8px, 2vw, 10px)",
              fontSize: "clamp(14px, 3vw, 16px)",
            }}
          >
            Relay Results
          </h5>
          {event.relayTeams
            .sort((a, b) => a.place - b.place)
            .map((team, teamIndex) => (
              <div
                key={teamIndex}
                style={{
                  marginBottom: "clamp(12px, 3vw, 15px)",
                  padding: "clamp(8px, 2vw, 10px)",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "clamp(8px, 2vw, 10px)",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <h6
                    style={{
                      margin: 0,
                      color: "#2c3e50",
                      fontSize: "clamp(14px, 3vw, 16px)",
                    }}
                  >
                    {team.place === 1
                      ? "🥇"
                      : team.place === 2
                      ? "🥈"
                      : team.place === 3
                      ? "🥉"
                      : `${team.place}.`}{" "}
                    {team.teamName}
                  </h6>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "clamp(14px, 3vw, 16px)",
                    }}
                  >
                    {team.totalTime}
                  </span>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
                    gap: "clamp(8px, 2vw, 10px)",
                  }}
                >
                  {team.swimmers.map((swimmer, swimmerIndex) => {
                    const split = team.splits.find(
                      (s) => s.leg === swimmer.leg
                    );
                    return (
                      <div
                        key={swimmerIndex}
                        style={{
                          textAlign: "center",
                          padding: "clamp(4px, 1vw, 5px)",
                          backgroundColor: "white",
                          borderRadius: "3px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "clamp(11px, 2vw, 12px)",
                            color: "#7f8c8d",
                          }}
                        >
                          Leg {swimmer.leg}
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "clamp(12px, 2.5vw, 14px)",
                          }}
                        >
                          {getPlayerName(swimmer)}
                        </div>
                        <div
                          style={{
                            fontSize: "clamp(12px, 2.5vw, 14px)",
                            color: "#2980b9",
                          }}
                        >
                          {split?.time || "N/A"}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  ));
};

export default SwimmingEventDetails;
